import {BaseService} from './baseService.js';
import {Service} from './service.js';

/* 
 * Handles interaction with the system update api
 */
export class SystemUpdateService extends BaseService {
	
	constructor() {	
		super();
	}
	
	async getUpdates(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}	
		var data = await this.makeGETRequest('/api/resource/system-updates' + params);		
		return data;
	}

	async saveUpdate(systemUpdate, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/system-updates/' + systemUpdate.updateId, systemUpdate);
		} else {
			saved = await this.makePOSTRequest('/api/resource/system-updates', systemUpdate);
		}
		return saved;
	}

	async deleteUpdate(updateId) {		
		var result = await this.makeDELETERequest('/api/resource/system-updates/' + updateId);		
		return result;
	}	
	
};


